const doc = [({"en":({"js":({"admin":({"subjects":({"select":({"choose_subject":"Choose subject"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;